
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import InvoiceCreatorDialog from '@/components/Transport/Accounting/InvoiceCreatorDialog.vue'
import { Invoice } from '@/models/accounting/Invoice'
import Notification from '@/classes/Notification'
import i18n from '@/i18n'

@Component({
	components: { InvoiceCreatorDialog }
})
export default class InvoiceEditDialog extends Vue {
	@Prop({ required: true })
	show!: boolean

	@Prop({ required: true })
	invoiceId!: string

	invoice: Invoice | null = null
	isLoading: boolean = false
	invoiceCreatorPreview: boolean = false

	async created() {
		await this.loadInvoice()
	}

	@Watch('invoiceId')
	async onInvoiceIdChange() {
		await this.loadInvoice()
	}

	async loadInvoice() {
		if (!this.invoiceId) return
		this.isLoading = true
		try {
			const response = await Invoice.with([
				'invoiceLines',
				'invoiceLines.product',
				'invoiceLines.vatCode',
				'customer',
				'transports'
			]).find(this.invoiceId)
			this.invoice = response.getData() as Invoice
		} catch (err) {
            // eslint-disable-next-line
			console.error('Error loading invoice', err)
			await Notification.Error(i18n.t('errors.load_error').toString())
			this.$emit('close')
		} finally {
			this.isLoading = false
		}
	}

	onClosed() {
		this.invoiceCreatorPreview = false
		this.$emit('close')
	}

	onInvoiceCreated() {
		this.invoiceCreatorPreview = false
		this.$emit('saved', { invoiceId: this.invoice?.getApiId() })
		this.$emit('close')
	}
}
